import React, { useEffect, useState } from 'react';
import Popover from "../popover/popover.js";
import * as impact from '../../api/impact';
import { formatNumber } from "../../util/numberFormatter";
import { getFlightSuffix } from "../../util/unitConverter";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./FlightImpact.css";



const FlightImpact = ({ merchantCode, showFrenchText}) => {
    const [fetchedFlightImpact, setFetchedFlightImpact] = useState(null);    
    useEffect(() => {
        impact.merchants(merchantCode, null, ['flightsImpact'] )
                .then(response => response.json())
                .then(body => {
                    setFetchedFlightImpact(body)
                })
                .catch(error => {
                    console.error(error);
                    setFetchedFlightImpact(error)
                })
    }, []);

    const passengerDistance = fetchedFlightImpact && !fetchedFlightImpact.error && formatNumber(Math.round(fetchedFlightImpact.flightsImpact?.passengerDistance?.value))
    const passengerDistanceUnit = fetchedFlightImpact && !fetchedFlightImpact.error && getFlightSuffix(fetchedFlightImpact.flightsImpact?.passengerDistance?.unit.toLowerCase());
    const numberOfPassengers = fetchedFlightImpact && !fetchedFlightImpact.error && formatNumber(fetchedFlightImpact.flightsImpact?.numberOfPassengers?.value);
    const carbonOffsetImpact = fetchedFlightImpact && !fetchedFlightImpact.error && formatNumber(Math.round(fetchedFlightImpact.carbonOffsetImpact?.value));
    const carbonOffsetImpactUnit = fetchedFlightImpact && !fetchedFlightImpact.error && fetchedFlightImpact.carbonOffsetImpact?.unit.toLowerCase()
    const treeGrowthYears = fetchedFlightImpact && !fetchedFlightImpact.error && formatNumber(fetchedFlightImpact.treeGrowthYears?.value);
   
    const treeMetric = treeGrowthYears && <span className="translate-dynamic"><span>An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as</span> <span className="no-translate"> {treeGrowthYears}</span> <span>trees have in one year.</span></span>
    
    return (
        <>
            <div className="center pt-4 mobile-hide">
                <h4 className="font-bold mt-0">Together We Are Fighting Climate Change</h4>
                <div className="row">
                    <div className="col-lg-3 col-md-6 mb-3">
                        <div className="p-3" >
                            <h3 className="title font-bold">{passengerDistance}</h3>
                            <h5 className="font-bold" >Carbon Neutral Air {passengerDistanceUnit}</h5>
                            {showFrenchText && <div className="font-italics" >{`Voyage neutre par km parcouru en avion`}</div>}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mb-3">
                        <div className="p-3" >
                            <h3 className="title font-bold">{numberOfPassengers}</h3>
                            <h5 className="font-bold" >Climate Friendly Travellers</h5>
                            {showFrenchText && <div className="font-italics" >{`Nombre de passagers eco friendly`}</div>}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mb-3">
                        <div className="p-3" >
                            <h3 className="title font-bold">{carbonOffsetImpact}</h3>
                            <h5 className="font-bold" >{carbonOffsetImpactUnit} of CO2 Offset</h5>
                            {showFrenchText && <div className="font-italics" >{`Kg de CO2 compensés`}</div>}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mb-3">
                        <div className="p-3" >
                            
                            <h3 className="title font-bold">{treeGrowthYears}</h3>
                            <h5 className="font-bold">
                                <span className="mr-2">Tree Growth Years</span>
                                <Popover content={treeMetric} >
                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                    </svg>
                                </Popover>
                            </h5>

                            {showFrenchText && <div className="font-italics" >{`Arbres`}</div>}
                        </div>
                    </div>
                </div>
            </div>


            <div className="mobile-show text-center py-3">
                <h4 className="font-bold mt-0">Together We Are Fighting Climate Change</h4>
                <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>

                    <div key="1" >
                        <div className="mb-3">
                            <div className="center w-100 px-3">
                                <div className="py-4 font-bold">
                                    <h2 className="title font-bold">{passengerDistance}</h2>
                                    <h5 className="font-bold" >Carbon Neutral Air {passengerDistanceUnit}</h5>
                                    {showFrenchText && <div className="font-italics" >{`Voyage neutre par km parcouru en avion`}</div>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div key="2" >
                        <div className="mb-3">
                            <div className="center w-100 px-3">
                                <div className="py-4 font-bold">
                                    <h2 className="title font-bold">{numberOfPassengers}</h2>
                                    <h5 className="font-bold" >Climate Friendly Travellers</h5>
                                    {showFrenchText && <div className="font-italics" >{`Nombre de passagers eco friendly`}</div>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div key="3">
                        <div className="mb-3">
                            <div className="center w-100 px-3">
                                <div className="py-4 font-bold">
                                    <h2 className="title font-bold">{carbonOffsetImpact}</h2>
                                    <h5 className="font-bold" >{carbonOffsetImpactUnit} of CO2 Offset</h5>
                                    {showFrenchText && <div className="font-italics" >{`Kg de CO2 compensés`}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div key="4">
                        <div className="mb-3">
                            <div className="center w-100 px-3">
                                <div className="py-4 font-bold">
                                    <h2 className="title font-bold">{treeGrowthYears}</h2>
                                    <h5 className="font-bold">
                                        <span className="mr-2">Tree Growth Years</span>
                                        <Popover content={treeMetric} >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                            </svg>
                                        </Popover>
                                    </h5>
                                    {showFrenchText && <div className="font-italics" >{`Arbres`}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        </>
    );
};





export default FlightImpact;